
import styled from "styled-components";

const StyledWrapper = styled.div`
    margin: 4rem 0rem;
`;

export default StyledWrapper;